let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("47nUw")).then(() => parcelRequire('6EvpZ'));